import { render, staticRenderFns } from "./ConsignmentFormWeightDirty.vue?vue&type=template&id=a720dd48&"
import script from "./ConsignmentFormWeightDirty.vue?vue&type=script&lang=js&"
export * from "./ConsignmentFormWeightDirty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports